import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import LoanTransactionListPageUI from './LoanTransactionListPageUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class LoanTransactionListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      transactionTypeTotalList: null,
      transactionList: null,
      loan: null,
      selectedTxnId: null,
      updateLoanBalanceMode: false
    }
  }

  render() {
    return (
      <LoanTransactionListPageUI
        context={this.props.context}
        loan={this.state.loan}
        selectedTxnId={this.state.selectedTxnId}
        transactionList={this.state.transactionList}
        transactionTypeTotalList={this.state.transactionTypeTotalList}
        errorList={this.state.errorList}

        updateLoanBalanceMode={this.state.updateLoanBalanceMode}
        onUpdateLoanBalanceCancelClick={this.onUpdateLoanBalanceCancelClick}
        onUpdateLoanBalanceClick={this.onUpdateLoanBalanceClick}

        onRefreshClick={this.onRefreshClick}
        onDownloadClick={this.onDownloadClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getTransactions(context)
    this.getLoan(context)
  }

  getTransactions(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/transactions`,
      cacheKey: CacheKeys.LoanTransactions(this.props.match.params.loanId),
      callback: this.getTransactionsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getTransactionsCallback = (response) => {
    this.setState({ errorList: response.errorList, transactionTypeTotalList: response.transactionTypeTotalList, transactionList: response.transactionList })
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      loan: response.loan,
    })
  }

  onDownloadClick = () => {
    const { loanId } = this.props.match.params;
    const url = `/api/su/loans/${loanId}/transactions/excel/fileDownloadSignedUrl`;
    this.setState({ downloadSubmitted: true });

    RestApiUtils.get(this.props.context, url, this.onDownloadClickCallback, null, null);
  }

  onDownloadClickCallback = (response) => {
    this.setState({ downloadSubmitted: false, downloadErrorList: response.errorList });

    if (response.errorList.length === 0) {
      const link = document.createElement('a');
      link.href = response.signedUrl.signedUrl;
      link.download = true;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error('Download error:', response.errorList);
    }
  }

  onUpdateLoanBalanceClick = (event) => {
    let txnId = event.currentTarget.getAttribute('data-id')
    // let selectedTxnId = this.state.transactionList.filter(p => p.transactionId === txnId)[0]
    this.setState({ updateLoanBalanceMode: true, selectedTxnId: txnId })
  }

  onUpdateLoanBalanceCancelClick = () => {
    this.setState({ updateLoanBalanceMode: false })
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.LoanTransactions(this.props.match.params.loanId))
    this.setState({ transactionTypeTotalList: null, transactionList: null, errorList: null },
      this.getTransactions(this.props.context)
    )
  }
}

export default withRouter(LoanTransactionListPageSF)